export enum SuccessPageDomainVariants {
  FLOWCODE = 'fc',
  FLOWPAGE = 'fp'
}
